import React, { useEffect, useState } from "react";
import bgImg from "../assets/images/mainBg.jpg";
import logo from "../assets/images/logo.png";
import AuthInput from "../components/global/AuthInput";
import Button from "../components/global/Button";
import CheckBox from "../components/global/CheckBox";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { login, setUserLocationAction } from "../redux/auth/authActions";
import { initializeToken } from "../redux/ApiClient";
import Footer from "../components/footer/Footer";

function Auth() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isPassword, setIsPassword] = useState(true);
  let togglePassword = () => {
    setIsPassword(!isPassword);
  };
  initializeToken();

  function handleLocationClick() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error);
    } else {
      toast.error("Geolocation not supported");
    }
  }

  useEffect(() => {
    handleLocationClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    dispatch(setUserLocationAction({ latitude, longitude }));
  }

  function error() {
    toast.error("Unable to retrieve your location");
  }

  const [showLoginForm, setShowLoginForm] = useState(true);

  let toggleForms = () => {
    setShowLoginForm(!showLoginForm);
  };

  let [state, setState] = useState({
    username: "",
    password: "",
  });

  let handleChange = (e) => {
    const value = e.target.value;
    setState({ ...state, [e.target.name]: value });
  };

  //   execute login process
  const submitForm = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (state.username && state.password) {
      dispatch(login(state)).then((status) => {
        if (status) {
          toast.success("Logged in successfuly");
          setLoading(false);
          window.location.href = "/auth";
        } else {
          toast.error("Failed to log you in.");
          setLoading(false);
        }
      });
    } else {
      setLoading(false);
      toast.error("All fields are required");
    }
  };

  //   send otp from forgotpass form
  let setOtpForm = () => {
    setLoading(true);
    if (state.username && state.password) {
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className="flex-1 h-screen overflow-hidden bg-fixed"
    >
      <div className="flex overflow-hidden bg-blue-500 bg-opacity-70 top-[5%] sm:top-[0%] sm:h-full bottom-[5%] left-[5%] sm:left-0 w-[90%] sm:w-full absolute sm:relative  rounded-3xl sm:rounded-none p-8 sm:p-0">
        {/* right side container */}
        <div className="sm:hidden md:hidden w-1/2 items-center flex justify-center">
          <div className="flex flex-col items-center justify-center">
            {/* <h1 className="text-white text-6xl font-audiowide-regular">
              PayGram
            </h1> */}
            <img className="h-44 rounded-full" src={logo} alt="Logo" />
          </div>
        </div>
        {/* end of eft container */}

        {/* right side container */}
        <div className=" py-[25%] flex-col flex justify-center items-center w-1/2 sm:w-full md:w-full sm:border-l-0 md:border-l-0 border-l border-l-secondary">
          {/* logo to be displayed on small devices only */}
          <div className="hidden sm:flex md:flex flex-col items-center justify-center mb-2">
            <img className="w-[30%] rounded-full" src={logo} alt="Logo" />
          </div>

          {/* body of the form */}
          {/* title */}
          <div className="my-4 m-auto flex justify-center">
            <h3 className="text-3xl sm:text-xl text-white font-bold">
              {showLoginForm ? "Sign In" : "Forgot Password"}
            </h3>
          </div>

          {/* form */}
          {showLoginForm && (
            <form onSubmit={submitForm}>
              <div className=" sm:px-1 w-[95%] sm:w-full">
                {/* input fields */}
                <AuthInput
                  prefix={
                    <i className="bx bxs-user-circle text-2xl text-gray-300"></i>
                  }
                  name="username"
                  type="text"
                  value={state.username}
                  onChange={handleChange}
                  required={true}
                  placeholder="username"
                />
                <AuthInput
                  prefix={
                    <i className="bx bxs-lock text-2xl text-gray-300"></i>
                  }
                  name="password"
                  type={isPassword ? "password" : "text"}
                  value={state.password}
                  onChange={handleChange}
                  required={true}
                  placeholder="Password"
                />
                <div className="flex flex-row items-center justify-between">
                  <CheckBox
                    value="0"
                    title="Show password"
                    onChange={togglePassword}
                    checked={isPassword}
                    textColor="text-white"
                  />
                </div>
              </div>

              {/* action button */}
              <div className="justify-center flex">
                {
                  <Button
                    bgColor={"bg-secondary"}
                    type="submit"
                    text="Sign in"
                    disabled={loading}
                  />
                }
              </div>
            </form>
          )}

          {/* reset password form */}
          {!showLoginForm && (
            <form onSubmit={setOtpForm}>
              <div className="px-8 sm:px-4 w-96 sm:w-full m-auto">
                <p className="text-sm text-white mb-4">
                  Enter your email so that we send you a One Time Password
                  (OTP).
                </p>
                {/* input fields */}
                <AuthInput
                  prefix={
                    <i className="bx bxs-user-circle text-2xl text-gray-300"></i>
                  }
                  name="email"
                  type="email"
                  value={state.username}
                  onChange={handleChange}
                  required={true}
                  placeholder="Email"
                />
              </div>

              {/* action button */}
              <div className="justify-center flex">
                {
                  <Button
                    bgColor={"bg-secondary"}
                    type="submit"
                    text={loading ? "Requesting..." : "Send OTP"}
                    disabled={loading}
                  />
                }
              </div>
            </form>
          )}
          <div className="flex flex-row mt-3 w-full justify-center items-center ">
            <p
              onClick={toggleForms}
              className="text-white cursor-pointer sm:text-sm"
            >
              {showLoginForm ? "Forgot password?" : "Back to login page"}
            </p>
          </div>
          <div className="flex flex-row mt-3 w-full justify-center items-center ">
            <p>No account? </p>
            <a
              href="/signup"
              className="text-white cursor-pointer sm:text-sm ml-2"
            >
              Sign up
            </a>
          </div>
          <div className="bottom-4 mt-[5%] w-full">
            <Footer />
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
}

export default Auth;
